import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { SiteDataProvider } from "@/context/SiteDataContext";
import { EditModeProvider } from "@/context/EditModeContext";
import EditBanner from "@/components/editable/EditBanner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Leadership from "@/pages/Leadership";
import { DepartmentsList, DepartmentDetail } from "@/pages/Departments";
import Events from "@/pages/Events";
import CalendarPage from "@/pages/CalendarPage";
import { NewsList, NewsDetail } from "@/pages/News";
import { PrelatePage, SupervisorPage, FirstLadyPage } from "@/pages/BioPage";
import Legacy from "@/pages/Legacy";
import Media from "@/pages/Media";
import Gallery from "@/pages/Gallery";
import MainHistory from "@/pages/MainHistory";
import ChurchLocator from "@/pages/ChurchLocator";
import Giving from "@/pages/Giving";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Prayer from "@/pages/Prayer";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import AdminDashboard from "@/pages/AdminDashboard";
import MemberDashboard from "@/pages/MemberDashboard";
import CustomPage from "@/pages/CustomPage";
import { DistrictsList, DistrictDetail } from "@/pages/Districts";
import Submit from "@/pages/Submit";
import Inbox from "@/pages/Inbox";
import ClaimPosition from "@/pages/ClaimPosition";
import LegalPage from "@/pages/LegalPage";
import {
  WomensLayout, WomensHome, WomensAbout, WomensLeadership,
  WomensBranches, WomensBranchDetail, WomensEvents, WomensNews,
  WomensGallery, WomensResources, WomensContact,
} from "@/pages/WomensDepartment";
import WomensHistory from "@/pages/WomensHistory";
import ThemeApplier from "@/components/ThemeApplier";
import FaviconApplier from "@/components/FaviconApplier";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/prelate" element={<PrelatePage />} />
        <Route path="/about/supervisor" element={<SupervisorPage />} />
        <Route path="/about/first-lady" element={<FirstLadyPage />} />
        <Route path="/legacy" element={<Legacy />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/departments" element={<DepartmentsList />} />
        <Route path="/departments/:id" element={<DepartmentDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/media" element={<Media />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/history" element={<MainHistory />} />
        <Route path="/locator" element={<ChurchLocator />} />
        <Route path="/giving" element={<Giving />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/prayer" element={<Prayer />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<MemberDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/pages/:slug" element={<CustomPage />} />
        <Route path="/districts" element={<DistrictsList />} />
        <Route path="/districts/:id" element={<DistrictDetail />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/claim-position" element={<ClaimPosition />} />
        <Route path="/privacy" element={<LegalPage key="privacy" slug="privacy" />} />
        <Route path="/terms" element={<LegalPage key="terms" slug="terms" />} />

        {/* Women's Department — mini-site with its own sub-nav */}
        <Route path="/womens" element={<WomensLayout><WomensHome /></WomensLayout>} />
        <Route path="/womens/about" element={<WomensLayout><WomensAbout /></WomensLayout>} />
        <Route path="/womens/leadership" element={<WomensLayout><WomensLeadership /></WomensLayout>} />
        <Route path="/womens/branches" element={<WomensLayout><WomensBranches /></WomensLayout>} />
        <Route path="/womens/branches/:id" element={<WomensLayout><WomensBranchDetail /></WomensLayout>} />
        <Route path="/womens/history" element={<WomensLayout><WomensHistory /></WomensLayout>} />
        <Route path="/womens/events" element={<WomensLayout><WomensEvents /></WomensLayout>} />
        <Route path="/womens/news" element={<WomensLayout><WomensNews /></WomensLayout>} />
        <Route path="/womens/gallery" element={<WomensLayout><WomensGallery /></WomensLayout>} />
        <Route path="/womens/resources" element={<WomensLayout><WomensResources /></WomensLayout>} />
        <Route path="/womens/contact" element={<WomensLayout><WomensContact /></WomensLayout>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteDataProvider>
            <EditModeProvider>
              <ThemeApplier />
              <FaviconApplier />
              <EditBanner />
              <AppRouter />
            </EditModeProvider>
          </SiteDataProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
